
import React, { useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import * as RestService from '../../services/eisRest';

const DocumentWarehouseItem = (props) => {


    const [t] = useTranslation();     
    const [item, setItem] = useState(null);
    const [active, setActive] = useState(false);
  //  const [unitPriceIncludeVat, setUnitPriceIncludeVat] = useState(0);
   // const [totalPriceIncludeVat, setTotalPriceIncludeVat] = useState(0);
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [showSerialNumberField, setShowSerialNumberField] = useState(false);
 //   const [article, setArticle] = useState(null);
  
   

    const handleOpenArticleList = () => {
        setShowArticleModalWithDatatable(true);
      }
  
    const handleCallbackArticleModalWithDatatable = (show,id) => {         
        setShowArticleModalWithDatatable(show);             
        getArticleData(id);
    };

    const getArticleData = (id) => {
        RestService.callAnyApi('article/getArticle?id='+id, null)
        .then((data) => {
       //   setArticle(data); 
          
          item.itemId=data.id;       
          item.um=data.measureUnit;         
          item.qty=1;
          item.itemName=data.name;
          //item.serialNumber = data.serialNumber;

          if(data.serialNumber===1){
            item.serialNumberEnabled=1;
            setShowSerialNumberField(true);
          }else{
            item.serialNumberEnabled=0;
            setShowSerialNumberField(false);
          }

          callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

  

 
    useEffect(() => {         
        setItem(props.item);      
    }, [props.item])

    useEffect(() => { 
        setActive(props.active);       
    }, [props.active])

    

    const handleEdit = () => {        
        callParent("edit");
    }

    const handleCopy = () => {        
        callParent("copy");
    }

    const handleDelete = () => {        
        callParent("delete");
    }

    const callParent = (action) => {
        if(item!=null){props.parentCallback(item,action)}
    }

  

    const handleChange = (e,elementName) => {
      
        if(item!=null){
            switch(elementName){
                case "itemName":
                    item.itemName=e.target.value;   //text               
                break;
                case "qty":
                    item.qty=e.floatValue;    //number                       
                break;             
                case "note":
                    item.note=e.target.value;   //text               
                break;
                case "internalNote":
                    item.internalNote=e.target.value;   //text               
                break;
                case "serialNumber":
                    item.serialNumber=e.target.value;   //text               
                break;
            }
            callParent("update")
        }
    };

   
   



    return (

               <>                 
                    <div className="row" style={{borderRadius: '5px'}}>
    					  	      					  	  
                            <div className="col-12 col-sm-12 col-lg-12">

                                    <div className="row">

                                        <div className="col-5 col-sm-5 col-lg-5" >
  
                                                <span style={!active ? { paddingTop: '15px'} : { display: 'none' }} >{item ? item.itemName : ""}</span>
                                                <div className="input-group mb-3 find-item" style={active ? {} : { display: 'none' }}>
                                                        <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                        </div>
                                  
                                                        <input type="text"  className="form-control col-12 col-sm-12 col-lg-12" placeHolder={t('document.label.findArticle') } readOnly onClick={handleOpenArticleList} value={item ? item.itemName : ""} onChange={(e) => {handleChange(e,"itemName")}}/>
                                                </div>
                                        </div>    
                                                  
                                        <div className="col-1 col-sm-1 col-lg-1">
                                                                                             
                                                <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator=","  style={active ? {} : { background: '#E9ECEF',marginBottom: '3px' }} value={item ? item.qty : 0} onValueChange={(values)  => {handleChange(values,"qty")}} />                                                
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
                                                                                             
                                                <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator=","  style={{background: '#E9ECEF'}} value={item ? item.posQty : 0}  />                                                
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                               {item && item.um!='' ? t('general.um.'+item.um) : ""}
                                        
                                        </div>

                                        <div className="col-3 col-sm-3 col-lg-3">
    
                                                <span id="textSerialNumber-0" style={!active && item && item.serialNumberEnabled===1 ? { fontSize: '13px', fontWeight: 'bold' } : { display: 'none' }}>{item ? item.serialNumber : ""}</span>
                                                <input type="text" className="form-control col-12 col-sm-12 col-lg-12" style={active  &&  item && item.serialNumberEnabled===1 ? {} : { display: 'none' }}  value={item ? item.serialNumber : ""} onChange={(e) => {handleChange(e,"serialNumber")}} placeholder={t('article.label.sn')} />
                                                  
                                        </div>


                                        <div className="col-1 col-sm-1 col-lg-1"  style={item && item.id!=='' ? {  } : { display: 'none' }} >
                                                
                                                <i className="fa fa-times fa-sm remove-operation" title={t('document.label.removeItem')} style={{marginTop: '15px', marginRight: '10px',color: '#FF0000'}} onClick={handleDelete}></i>
                                                <i className="fas fa-copy fa-sm copy-operation" title={t('document.label.copyItem')} style={{marginTop: '15px',marginRight: '10px',color: '#007BFF'}} onClick={handleCopy}></i>
                                                <i className="far fa-edit fa-sm edit-operation" title={t('document.label.editItem')}  style={{marginTop: '15px',marginRight: '10px',color: '#469623'}} onClick={handleEdit}></i>                                             

                                        </div>
                                        
                                     </div> 
                                     


                            </div>

                    </div>
                
                    <ArticleModalWithDatatable            
                          parentCallback={handleCallbackArticleModalWithDatatable}    
                          modal={showArticleModalWithDatatable}                                
                    />

                </>
                   
    );

}

export default DocumentWarehouseItem;